import { trimEnd, kebabCase } from 'lodash-es';

export const getBlogTopicUrl = topic => {
  return `/blog/topic/${topic.toLowerCase()}/`;
};

export const getPrimaryTag = tags => {
  const defaultTag = 'OTHER';

  if (!tags || tags.length === 0) return defaultTag;
  return tags[0] || defaultTag;
};

export const capitalize = str => {
  if (!str || str.length < 2) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getSlugName = caseStudy => {
  const fullSlug = trimEnd(caseStudy.fields.slug, '/');
  const lastPart = fullSlug.split('/').pop();
  return lastPart;
};
export const setDataLayer = data => {
  /**
   *  Format of data:
   *    const data = {
   *    event: 'formAction',
   *    formName: 'free_consultation',
   *    formActionType: actionType
   *    inputError: inputType (Optional)
   *  };
   */

  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push(data);
};

export const getValidAuthorSlug = slug => {
  return `authors/${kebabCase(slug)}/`;
};

export const removeHTMLTags = textWithTags => {
  return textWithTags.replace(/<[^>]*>?/gm, '');
};
